const isRecette = process.env.VUE_APP_ENVIRONMENT && process.env.VUE_APP_ENVIRONMENT === "recette";

const config = {
  loginUrl: `${process.env.VUE_APP_API_URL}/login`,
  logoutUrl: `${process.env.VUE_APP_API_URL}/logout`,
  api: {
    baseUrl: `${process.env.VUE_APP_API_URL}/api`,
    debounceDelay: 750,
  },
  isProd: process.env.NODE_ENV === "production",
  supportedLocales: {
    fr: "Français",
    de: "Deutsch",
  },
  urlFr: "https://hub.lde.fr/",
  rgpdUrl: "https://portail-univers-cristal.lde.fr/rgpd",
};

export default config;
